module.exports = __webpack_public_path__ + "images/lightbox/next.gif";